import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { AuthCenteredLayout } from 'src/layouts/auth-centered';

import { SplashScreen } from 'src/components/loading-screen';

import { GuestGuard } from 'src/auth/guard';

// ----------------------------------------------------------------------

const Jwt = {
  SignInPage: lazy(() => import('src/pages/auth/sign-in')),
  VerifyPage: lazy(() => import('src/pages/auth/verify')),
  ResetPasswordPage: lazy(() => import('src/pages/auth/reset-password')),
  UpdatePasswordPage: lazy(() => import('src/pages/auth/update-password')),
  AddAccountPage: lazy(() => import('src/pages/auth/add-account')),
};

// ----------------------------------------------------------------------

export const authRoutes = [
  {
    path: 'auth',
    element: (
      <Suspense fallback={<SplashScreen />}>
        <AuthCenteredLayout>
          <Outlet />
        </AuthCenteredLayout>
      </Suspense>
    ),
    children: [
      { path: 'update-password/:token', element: <Jwt.UpdatePasswordPage /> },
      {
        element: (
          <GuestGuard>
            <Outlet />
          </GuestGuard>
        ),
        children: [
          { path: 'sign-in', element: <Jwt.SignInPage /> },
          { path: 'verify', element: <Jwt.VerifyPage /> },
          { path: 'request-reset', element: <Jwt.ResetPasswordPage /> },
          { path: 'add-account', element: <Jwt.AddAccountPage /> },
        ],
      },
    ]
  },
];
